import React from 'react';

import ReactPlayer from 'react-player';

import { IVideoPlayerProps } from 'interfaces/Players/players';

export default function VideoPlayer({ url }: IVideoPlayerProps) {
  return (
    <div className="w-full h-full p-4 flex flex-col justify-center items-center">
      <ReactPlayer url={url} controls={true} width="100%" height="100%" />
    </div>
  );
}
